import React from "react";
import PropTypes from "prop-types";
import "../../ClassesShared/classesShared.css";

export default function DetailField({ label, children, wide = false }) {
  return (
    <div className={wide ? "col-12 mb-3" : "col-sm-6 mb-3"}>
      <dt className="small text-uppercase font-weight-normal classes-text-tertiary">{label}</dt>
      <dd className="classes-text-primary mb-0">{children || "—"}</dd>
    </div>
  );
}

DetailField.propTypes = { label: PropTypes.string.isRequired, children: PropTypes.node, wide: PropTypes.bool };
